module.exports = __webpack_public_path__ + "img/8-map.1f41ec28.jpg";